// extracted by mini-css-extract-plugin
module.exports = {"controlContainer":"widget-space--controlContainer--1F4XU","controlItem":"widget-space--controlItem--3vKLB","button":"widget-space--button--ZURsb"};